var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMetamask = function SvgMetamask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 120,
    viewBox: "0 0 126 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.474 115.892L90.5407 107.908L70.2294 119.995L56.0585 119.989L35.7354 107.908L8.8141 115.892L0.625 88.3718L8.8141 57.8286L0.625 32.005L8.8141 0L50.8808 25.0193H75.407L117.474 0L125.663 32.005L117.474 57.8286L125.663 88.3718L117.474 115.892Z",
    fill: "#FF5C16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82812 0L50.8949 25.0369L49.2218 42.2194L8.82812 0Z",
    fill: "#FF5C16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 88.3828L54.2591 102.419L35.75 107.908V88.3828Z",
    fill: "#FF5C16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7776 65.1815L49.2202 42.2344L26.4492 57.8377L26.4375 57.8318V57.8436L26.5079 73.9048L35.742 65.1815H35.7478H52.7776Z",
    fill: "#FF5C16"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.481 0L75.4141 25.0369L77.0812 42.2194L117.481 0Z",
    fill: "#FF5C16"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.556 88.3828L72.0469 102.419L90.556 107.908V88.3828Z",
    fill: "#FF5C16"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8655 57.8436H99.8714H99.8655V57.8318L99.8596 57.8377L77.0887 42.2344L73.5312 65.1815H90.5611L99.8009 73.9048L99.8655 57.8436Z",
    fill: "#FF5C16"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7354 107.908L8.8141 115.891L0.625 88.3828H35.7354V107.908Z",
    fill: "#E34807"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7599 65.1719L57.9023 98.3451L50.7758 79.9005L26.4844 73.901L35.7243 65.1719H52.7541H52.7599Z",
    fill: "#E34807"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5547 107.908L117.476 115.891L125.665 88.3828H90.5547V107.908Z",
    fill: "#E34807"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5174 65.1719L68.375 98.3451L75.5016 79.9005L99.793 73.901L90.5472 65.1719H73.5174Z",
    fill: "#E34807"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 88.3714L8.8141 57.8281H26.4251L26.4896 73.8952L50.781 79.8947L57.9076 98.3392L54.2445 102.401L35.7354 88.3655H0.625V88.3714Z",
    fill: "#FF8D5D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.658 88.3714L117.469 57.8281H99.8575L99.793 73.8952L75.5016 79.8947L68.375 98.3392L72.0381 102.401L90.5472 88.3655H125.658V88.3714Z",
    fill: "#FF8D5D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4043 25.0156H63.1412H50.8781L49.2109 42.1981L57.9049 98.3184H68.3775L77.0774 42.1981L75.4043 25.0156Z",
    fill: "#FF8D5D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8141 0L0.625 32.005L8.8141 57.8286H26.4251L49.2078 42.2194L8.8141 0Z",
    fill: "#661800"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6812 71.834H39.7034L35.3594 76.0724L50.7925 79.8822L47.6812 71.8281V71.834Z",
    fill: "#661800"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M117.472 0L125.661 32.005L117.472 57.8286H99.8608L77.0781 42.2194L117.472 0Z",
    fill: "#661800"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6171 71.834H86.6066L90.9507 76.0782L75.5 79.8939L78.6171 71.8281V71.834Z",
    fill: "#661800"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2193 109.047L72.0391 102.414L68.376 98.3516H57.8975L54.2344 102.414L56.0542 109.047",
    fill: "#661800"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2198 109.047V120.001H56.0547V109.047H70.2198Z",
    fill: "#C0C4CD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7422 107.895L56.0711 119.994V109.04L54.2513 102.406L35.7422 107.895Z",
    fill: "#E7EBF6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5555 107.895L70.2266 119.994V109.04L72.0464 102.406L90.5555 107.895Z",
    fill: "#E7EBF6"
  })));
};
export default SvgMetamask;